var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 64,
    viewBox: "0 0 87 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 53.3334V24.0001C5.33325 21.0546 7.72107 18.6667 10.6666 18.6667H53.3333C56.2789 18.6667 58.6666 21.0546 58.6666 24.0001V53.3334C58.6666 56.279 56.2789 58.6667 53.3333 58.6667H10.6666C7.72107 58.6667 5.33325 56.279 5.33325 53.3334Z",
    stroke: "#78350F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 6.66675L32.0001 16.0001L41.3334 6.66675",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 42,
    y: 2,
    width: 45,
    height: 45,
    rx: 20,
    fill: "#A21CAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvIcon);
export default __webpack_public_path__ + "static/media/tv_icon.7421d230d2e989c7392d8e143c19dce0.svg";
export { ForwardRef as ReactComponent };